import L from "leaflet";

// Fix default icons for React-Leaflet in bundlers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

export const parcelIcon = (verified) =>
  L.divIcon({
    className: "acre-marker",
    html: `<div style="
      width:14px;height:14px;border-radius:50%;
      background:${verified ? "#10B981" : "#F59E0B"};
      border:2px solid #0F172A;
      box-shadow:0 0 0 2px ${verified ? "#10B981" : "#F59E0B"}55;
    "></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
  });
